import React, { Component } from "react";
import CssClasses from "./Ticket.css";
import TicketTypeButton from "../UI/TicketTypeButton/TicketTypeButton";
import TicketPairItem from "../UI/TicketPairItem/TicketPairItem";
import CheckboxGroup from "../UI/CheckboxGroup/CheckboxGroup";
import { connect } from "react-redux";
import * as StoreActions from "../../ReduxStore/Actions/ActionIndex";
import TransitionGroup from "react-transition-group/TransitionGroup";
import CSSTransition from "react-transition-group/CSSTransition";
import { GetConvertedOdds } from "../../HOCs/Helpers/OddConverter";
import SiteIcons from "../../assets/fonts/site_icons/style.css";

import NumericKeyboard, {
  ADJUSTED_FOR_ENTERING_BET_AMOUNT
} from "../../Components/Keyboards/NumericKeyboard/NumericKeyboard";
import Auxx from "../../HOCs/AUXX/Auxx";
import beepMedium from "../../assets/sounds/beep_medium.mp3";

//import imgCheckmark from "../../assets/images/icons/icon_checkmark.png";

export const TICKET_TYPE_COMBO = 2;
export const TICKET_TYPE_SYSTEM = 3;

class Ticket extends Component {
  state = {
    shouldAddFlicker: false,
    isConfirmingBet: false,
    toastWarningMessage: "",
    showsNumbericKeyboard: false
  };

  lastPairCount = 0;

  componentDidMount() {}

  checkAllPairs = () => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    this.props.onSelectAllPairs();
  };

  getNumberOfBets = () => {
    var numOfBets = 0;
    var activeBets = this.props.ticketPairInfo.filter(x => x.checked);

    console.log("CHECKED BETS: ", activeBets);

    if (this.props.currentTicketTypeID === TICKET_TYPE_COMBO) {
      //combo
      numOfBets = activeBets.length;
      console.log("COMBO: ", numOfBets);
    } else if (this.props.currentTicketTypeID === TICKET_TYPE_SYSTEM) {
      //system - izracunaj odvojeno fixane i nefixane
      var numFixed = activeBets.filter(x => x.isFix).length;

      if (numFixed === 0) {
        numOfBets = activeBets.length;
      } else {
        numOfBets = "F" + numFixed + "+" + (activeBets.length - numFixed);
      }

      console.log("SYS: ", numOfBets);
    }

    console.log("NUMBETS " + numOfBets);

    return numOfBets;
  };

  uncheckAllPairs = () => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    this.props.onDeselectAllPairs();

    this.setState({ shouldAddFlicker: false });
  };

  removeAllPairs = () => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    this.props.onRemoveAllPairs();
  };

  txtAmount_Enter = event => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    this.setState({ showsNumbericKeyboard: true });

    // console.log("ENTER");

    // //resetiraj amount
    this.props.updateBetAmount(0);
  };

  txtAmountCombination_Enter = combID => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    this.setState({ showsNumbericKeyboard: true });

    // console.log("ENTER COMB ID ", combID);

    // //resetiraj amount za tu comb
    this.props.setCurrentlyEditedCombinationID(combID);
    this.props.updateCombinationBetAmount(combID, 0);
  };

  onCloseNumericKeyboard = () => {
    this.setState({ showsNumbericKeyboard: false });
  };

  numericKeyboard_KeyDown = (value, isQuickPick) => {
    console.log("VALUE ", value);

    if (this.props.currentComboTextboxID > 0) {
      //iz systema
      this.handleUpdateSystemTicket(value, isQuickPick);
    } else {
      this.handleUpdateComboTicket(value, isQuickPick);
      //iz obicnog
    }
  };

  handleUpdateComboTicket = (value, isQuickPick) => {
    //dohvati stari bet amount
    let oldAmount = 0;
    oldAmount = this.props.comboBetAmount;

    if (value === -2) {
      //delete!
      this.props.updateBetAmount(0);

      return;
    }

    if (this.props.comboBetAmount === 0) {
      oldAmount = "";
    }

    if (isQuickPick) {
      if (oldAmount === "") {
        oldAmount = 0;
      }

      this.props.updateBetAmount(parseInt(oldAmount, 10) + value);
    } else {
      if (value === -1) {
        //decimala, ako vec ima ili je prazno, ignore
        if (oldAmount === "" || oldAmount.indexOf(".") !== -1) {
          //ignore
          console.log("DOT RETURN");
          return;
        }
        console.log("DOT ADD");
        oldAmount += ".00";
      } else {
        oldAmount += "" + value;
      }

      let newAmount = parseFloat(oldAmount);
      this.props.updateBetAmount(newAmount);
    }
  };

  handleUpdateSystemTicket = (value, isQuickPick) => {
    //dohvati stari bet amount
    let oldAmount = 0;

    //dohvati stari bet amount iz sistema
    var system = this.props.systemCombinations.find(
      x => x.id === this.props.currentComboTextboxID
    );

    if (system === undefined) {
      //smisli jos
      alert("Undefined system! ", this.props.currentComboTextboxID);
      return;
    }

    oldAmount = system.betTotal.toString();

    if (value === -2) {
      //delete!
      this.props.updateCombinationBetAmount(
        this.props.currentComboTextboxID,
        0
      );
      return;
    }

    if (system.betTotal === 0) {
      oldAmount = "";
    }

    if (isQuickPick) {
      if (oldAmount === "") {
        oldAmount = 0;
      }

      this.props.updateCombinationBetAmount(
        this.props.currentComboTextboxID,
        parseFloat(oldAmount) + value
      );
    } else {
      if (value === -1) {
        //decimala, ako vec ima ili je prazno, ignore
        if (oldAmount === "" || oldAmount.indexOf(".") !== -1) {
          //ignore
          console.log("DOT RETURN");
          return;
        }
        console.log("DOT ADD");
        oldAmount += ".00";
      } else {
        oldAmount += value;
      }

      let newAmount = parseFloat(oldAmount);
      this.props.updateCombinationBetAmount(
        this.props.currentComboTextboxID,
        newAmount
      );
    }
  };

  btnChangeTicketType_Click = typeID => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    //za hotswap dok je tipkovinica
    if (typeID === TICKET_TYPE_COMBO) {
      this.props.setCurrentlyEditedCombinationID(0);
    }

    this.props.setTicketType(typeID);

    this.setState({ shouldAddFlicker: true });
  };

  btnRemovePair_Click = matchID => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    this.props.onRemovePair(matchID);
  };

  chkPairIsActive_Change = (matchID, event) => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    let isChecked = event.target.checked;
    this.props.onChangePairCheckedState(matchID, isChecked);
  };

  chkIsFix_Change = matchID => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    this.props.onTogglePairFixState(matchID);
  };

  btnPlaceBet_Click = () => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    //gasi kb
    this.setState({ showsNumbericKeyboard: false });

    if (this.props.currentTicketTypeID === TICKET_TYPE_SYSTEM) {
      //sistem, provjeri
      //provjeri da sve oznacene imaju i vrijednost unesenu
      let count = this.props.systemCombinations.filter(
        x => x.isChecked && x.betPerCombination === 0
      ).length;

      if (count > 0) {
        //nemore!

        this.showToastMessage(
          "Unesite željeni iznos za uplatu za sve označene sisteme"
        );

        return;
      }

      //zatim provjeri da je barem jedna oznacena i ima iznos
      count = this.props.systemCombinations.filter(
        x => x.isChecked && x.betPerCombination > 0
      ).length;

      if (count < 1) {
        //nemore!
        this.showToastMessage(
          "Odaberite barem jedan sistem i unesite željeni iznos za uplatu"
        );

        return;
      }
    }

    //provjeri prvo ako je confirming bet
    if (this.state.isConfirmingBet) {
      //vrti
      this.props.startLoading(false, false);

      //uz delay da prvo ide gui update
      // setTimeout(() => {
      //   window.cefCustomObject.printTicket(
      //     JSON.stringify(this.props.ticketPairInfo)
      //   );
      // }, 100);

      setTimeout(() => {
        this.props.stopLoading(false);
        this.setState({ isConfirmingBet: false });
      }, 3500);
    } else {
      //provjeri da ima betamount
      if (
        this.props.currentTicketTypeID === TICKET_TYPE_COMBO &&
        this.props.betAmount === 0
      ) {
        //nemore!
        this.showToastMessage("Unesite iznos oklade!");

        return;
      }

      //provjeri i da ima dovoljno love za taj amount
      if (this.getTotalBet() > this.props.currentBalance) {
        //nemore
        this.showToastMessage(
          "Saldo je manji od unesenog iznosa! Dodajte novac u kladomat ili smanjite iznos oklade."
        );
        return;
      }

      //provjeri da nema previse parova
      if (this.getNumberOfBets() > this.props.machineInfo.MaxPairs) {
        //nemore
        this.showToastMessage(
          "Na listiću se može nalaziti maksimalno " +
            this.props.machineInfo.MaxPairs +
            " parova!"
        );
        return;
      }

      //provjeri da je unio manje od minimuma
      if (this.getTotalBet() < this.props.machineInfo.MinBetAmountCents) {
        //nemore
        this.showToastMessage(
          "Minimalni ulog je " +
            (this.props.machineInfo.MinBetAmountCents * 0.01).toFixed(2) +
            this.props.machineInfo.CurrencyCode +
            "!"
        );
        return;
      }

      //provjeri da je unio vise od maximuma
      if (this.getTotalBet() > this.props.machineInfo.MaxBetAmountCents) {
        //nemore
        this.showToastMessage(
          "Maksimalni ulog je " +
            (this.props.machineInfo.MaxBetAmountCents * 0.01).toFixed(2) +
            this.props.machineInfo.CurrencyCode +
            "!"
        );
        return;
      }

      //provjeri da je dobitak manji od maximalnog
      if (this.getPossibleWin() > this.props.machineInfo.MaxWinAmountCents) {
        //nemore
        this.showToastMessage(
          "Dobitak listića ne može prelaziti " +
            (this.props.machineInfo.MaxWinAmountCents * 0.01).toFixed(2) +
            this.props.machineInfo.CurrencyCode +
            "!"
        );
        return;
      }

      //this.setState({ isConfirmingBet: true }); nema vise confirminga
      //direkt postavi
      this.props.setTicketNumberForDetails(1);

      //gasi keyb
      this.props.changeNumericKeyboardVisibility(false);

      //pokazi popaps
      // if (this.props.currentTicketTypeID === 3) {
      //   this.props.setIsShowingSystemCombinationsPopup(true);
      // }
    }
  };

  showToastMessage = msg => {
    this.setState({
      toastWarningMessage: msg
    });

    //i gasi nakon 3 sec
    setTimeout(() => {
      this.setState({ toastWarningMessage: "" });
    }, 3500);
  };

  btnCancel_Click = () => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    console.log(this.props.ticketPairInfo);

    //alert('cancel!"');

    //provjeri prvo ako je confirming bet
    if (this.state.isConfirmingBet) {
      this.setState({ isConfirmingBet: false });
    } else {
      this.removeAllPairs();
    }
  };

  btnSystemOf_Click = systemID => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    //alert(systemID);
    //napravi toggle za taj system id
    this.props.toggleSystemActiveState(systemID);
  };

  btnShowPossibleCombinations_Click = () => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    //gasi kb kako god
    this.props.setCurrentlyEditedCombinationID(-1);
    this.props.changeNumericKeyboardVisibility(false);

    let count = 0;

    //provjeri da sve oznacene imaju i vrijednost unesenu
    count = this.props.systemCombinations.filter(
      x => x.isChecked && x.betPerCombination === 0
    ).length;

    if (count > 0) {
      this.showToastMessage(
        "Unesite željeni iznos za uplatu za sve označene sisteme"
      );

      return;
    }

    //zatim provjeri da je barem jedna oznacena i ima iznos
    count = this.props.systemCombinations.filter(
      x => x.isChecked && x.betPerCombination > 0
    ).length;

    if (count < 1) {
      this.showToastMessage(
        "Odaberite barem jedan sistem i unesite željeni iznos za uplatu"
      );

      return;
    }

    this.props.setIsShowingSystemCombinationsPopup(true);
  };

  adjustedHeightForSystems = () => {
    //ako nije sistem, nista
    if (this.props.currentTicketTypeID === TICKET_TYPE_COMBO) {
      return "";
    }

    //parovi
    var pairs = [...this.props.ticketPairInfo];

    //filtriraj bez fixa
    pairs = pairs.filter(x => !x.isFix);

    var count = pairs.length;

    if (count === 3) {
      return CssClasses.adjustedHeightForSystemOf3;
    }

    if (count === 4) {
      return CssClasses.adjustedHeightForSystemOf4;
    }

    if (count === 5) {
      return CssClasses.adjustedHeightForSystemOf5;
    }

    if (count === 6) {
      return CssClasses.adjustedHeightForSystemOf6;
    }

    if (count === 7) {
      return CssClasses.adjustedHeightForSystemOf7;
    }

    if (count === 8) {
      return CssClasses.adjustedHeightForSystemOf8;
    }

    if (count === 9) {
      return CssClasses.adjustedHeightForSystemOf9;
    }

    if (count === 10) {
      return CssClasses.adjustedHeightForSystemOf10;
    }

    if (count === 11) {
      return CssClasses.adjustedHeightForSystemOf11;
    }

    if (count === 12) {
      return CssClasses.adjustedHeightForSystemOf12;
    }

    if (count === 13) {
      return CssClasses.adjustedHeightForSystemOf13;
    }

    if (count === 14) {
      return CssClasses.adjustedHeightForSystemOf14;
    }

    if (count === 15) {
      return CssClasses.adjustedHeightForSystemOf15;
    }

    if (count === 16) {
      return CssClasses.adjustedHeightForSystemOf16;
    }

    if (count === 17) {
      return CssClasses.adjustedHeightForSystemOf17;
    }

    if (count === 18) {
      return CssClasses.adjustedHeightForSystemOf18;
    }

    //po defaultu jebiga nis ne vrati
    return "";
  };

  getPossibleWin = () => {
    if (this.props.currentTicketTypeID === TICKET_TYPE_COMBO) {
      //regularan tiket
      return this.props.betAmount * this.props.totalOdds;
    } else if (this.props.currentTicketTypeID === TICKET_TYPE_SYSTEM) {
      //izracunaj iz kombinacija
      let maxWin = 0;

      this.props.systemCombinations.forEach(system => {
        system.combinationList.forEach(comb => {
          maxWin += comb.possibleWin;
        });
      });

      return maxWin;
    }
  };

  getTotalBet = () => {
    if (this.props.currentTicketTypeID === TICKET_TYPE_COMBO) {
      //regularan tiket
      return this.props.betAmount;
    } else if (this.props.currentTicketTypeID === TICKET_TYPE_SYSTEM) {
      //izracunaj iz kombinacija
      let totalBet = 0;

      this.props.systemCombinations.forEach(system => {
        totalBet += system.betTotal;
      });
      return totalBet;
    }
  };

  render() {
    //ako nema parova, nema nista!
    if (this.props.ticketPairInfo.length === 0) {
      return null;
    }

    // console.log(
    //   "LAST COUNT " +
    //     this.lastPairCount +
    //     " LENG " +
    //     this.props.ticketPairInfo.length
    // );

    let addFlicker = this.props.ticketPairInfo.length !== this.lastPairCount;
    this.lastPairCount = this.props.ticketPairInfo.length;

    // console.log(
    //   "NEW COUNT " +
    //     this.lastPairCount +
    //     " LENG " +
    //     this.props.ticketPairInfo.length
    // );

    console.log("TICKETTPYE: ", this.props.currentTicketTypeID);
    console.log("SYSINFOS: ", this.props.systemCombinations);
    console.log("PAIR INFOES: ", this.props.ticketPairInfo);

    return (
      <div className={CssClasses.container}>
        {this.state.showsNumbericKeyboard ? (
          <Auxx>
            <div className={CssClasses.keyboardBackground}>&nbsp;</div>
            <NumericKeyboard
              hasQuickPick
              closeHandler={() => {
                this.onCloseNumericKeyboard();
              }}
              keyDownHandler={(value, isQuickPick) => {
                this.numericKeyboard_KeyDown(value, isQuickPick);
              }}
              customClass={ADJUSTED_FOR_ENTERING_BET_AMOUNT}
            />
          </Auxx>
        ) : null}

        <audio
          ref={sound => {
            this.beepMedium = sound;
          }}
        >
          <source src={beepMedium} type="audio/mpeg" />
        </audio>

        {/* <TicketTypeButton
          onButtonClicked={id => this.btnChangeTicketType_Click(id)}
          title="Single"
          id={1}
          isActive={this.state.currentTicketTypeID === 1}
        /> */}
        <TicketTypeButton
          onButtonClicked={id => this.btnChangeTicketType_Click(id)}
          title="Combo"
          id={2}
          isActive={this.props.currentTicketTypeID === TICKET_TYPE_COMBO}
        />
        <TicketTypeButton
          onButtonClicked={id => this.btnChangeTicketType_Click(id)}
          title="System"
          id={3}
          isActive={this.props.currentTicketTypeID === TICKET_TYPE_SYSTEM}
        />
        <div
          className={[
            CssClasses.pairContainer,
            addFlicker ? CssClasses.shortFlicker : "",
            this.adjustedHeightForSystems()
          ].join(" ")}
        >
          <TransitionGroup>
            {this.props.ticketPairInfo.map(pair => {
              return (
                <CSSTransition
                  key={pair.coefID}
                  timeout={500}
                  classNames="fade"
                >
                  <TicketPairItem
                    betID={pair.betID}
                    matchID={pair.matchID}
                    matchName={pair.matchName}
                    betName={pair.betName}
                    odds={GetConvertedOdds(
                      this.props.currentOddFormat,
                      pair.odds
                    )}
                    pick={pair.pick}
                    checked={pair.checked}
                    isFix={pair.isFix}
                    isLive={pair.isLive}
                    paused={!pair.isEnabled}
                    onCheckChanged={this.chkPairIsActive_Change}
                    onToggleFix={this.chkIsFix_Change}
                    onRemovePair={this.btnRemovePair_Click}
                    changeDirection={pair.direction}
                    isForSystem={
                      this.props.currentTicketTypeID === TICKET_TYPE_SYSTEM
                    }
                    systemLegend={pair.systemLegend}
                  />
                </CSSTransition>
              );
            })}
          </TransitionGroup>
        </div>
        <div className={CssClasses.infoGroup}>
          <span className={CssClasses.lblNumberOfBets}>
            Broj oklada: {this.props.numberOfBetsFormatted}
          </span>
          <CheckboxGroup type="remove" onClick={this.removeAllPairs} />
          <CheckboxGroup type="uncheck" onClick={this.uncheckAllPairs} />
          <CheckboxGroup type="check" onClick={this.checkAllPairs} />
        </div>

        <div className={CssClasses.clearFix} />

        {this.props.currentTicketTypeID === TICKET_TYPE_SYSTEM &&
        this.props.ticketPairInfo.filter(
          x => x.checked && x.isShown && x.isEnabled
        ).length < 2 ? (
          <div
            className={[CssClasses.infoGroup, CssClasses.chooseSystemRow].join(
              " "
            )}
          >
            <span
              className={[
                SiteIcons.site_icon_info,
                CssClasses.systemInfoIcon
              ].join(" ")}
            />
            <span className={CssClasses.lblChooseSystem}>
              Odaberite najmanje 2 događaja!
            </span>
          </div>
        ) : this.props.currentTicketTypeID === TICKET_TYPE_SYSTEM &&
          this.props.systemCombinations.filter(x => x.isChecked).length < 1 ? (
          <div
            className={[CssClasses.infoGroup, CssClasses.chooseSystemRow].join(
              " "
            )}
          >
            <span
              className={[
                SiteIcons.site_icon_info,
                CssClasses.systemInfoIcon
              ].join(" ")}
            />
            <span className={CssClasses.lblChooseSystem}>
              Odaberite najmanje 1 sistem
            </span>
          </div>
        ) : null}

        <div className={CssClasses.clearFix} />

        {this.props.currentTicketTypeID === TICKET_TYPE_SYSTEM ? (
          <div className={CssClasses.systemPickerContainer}>
            {this.props.systemCombinations.map(comb => {
              //u petlji napravi za sve ovo gumbeke
              return (
                <div
                  className={[
                    CssClasses.systemButton,
                    comb.isChecked ? CssClasses.systemBtnActive : ""
                  ].join(" ")}
                  onClick={() => this.btnSystemOf_Click(comb.id)}
                >
                  {/* {comb.isChecked ? (
                    <div className={CssClasses.indicatorSection}>
                      <img
                        className={CssClasses.imgCheckmark}
                        src={imgCheckmark}
                        alt=""
                      />
                    </div>
                  ) : null} */}

                  <div className={CssClasses.titleSection}>{comb.title}</div>
                </div>
              );
            })}
          </div>
        ) : null}

        {this.props.systemCombinations.filter(x => x.isChecked).length > 0 ? (
          <div className={CssClasses.systemSeparatorLine}>
            <hr className={CssClasses.hrLine} />
          </div>
        ) : null}

        {this.props.currentTicketTypeID === TICKET_TYPE_SYSTEM ? (
          <div className={CssClasses.systemPickerContainer}>
            {this.props.systemCombinations
              .filter(x => x.isChecked)
              .map(comb => {
                //u petlji napravi za sve ovo gumbeke
                return (
                  <div
                    key={comb.id}
                    className={[
                      CssClasses.infoGroup,
                      CssClasses.alternateRow,
                      CssClasses.amountRowSystem
                    ].join(" ")}
                  >
                    <div className={[CssClasses.systemNameLbl].join(" ")}>
                      <div className={CssClasses.titleSection}>
                        {comb.title} ({comb.combinationsTotal})
                      </div>
                    </div>

                    {comb.isChecked ? (
                      <input
                        type="text"
                        className={[
                          CssClasses.txtBetAmountSystem,
                          this.props.isShowingNumericKeyboard
                            ? CssClasses.txtBetAmountActive
                            : ""
                        ].join(" ")}
                        value={(comb.betTotal * 0.01).toFixed(2)}
                        // onChange={this.txtAmount_Change}
                        onClick={() => this.txtAmountCombination_Enter(comb.id)}
                        onSelect={ev => {
                          ev.target.selectionStart = ev.target.selectionEnd;
                        }}
                        readOnly
                      />
                    ) : null}
                    {comb.isChecked ? (
                      <div className={CssClasses.lblBetPerComb}>
                        {(comb.betPerCombination * 0.01).toFixed("3") +
                          this.props.machineInfo.CurrencyCode}
                      </div>
                    ) : null}

                    <div className={CssClasses.clearFix} />
                  </div>
                );
              })}
          </div>
        ) : null}

        {/* {this.props.currentTicketTypeID === 3 &&
        this.props.systemCombinations.filter(x => x.isChecked).length !== 0 ? (
          <div
            className={[CssClasses.infoGroup, CssClasses.chooseSystemRow].join(
              " "
            )}
          >
            <span
              className={CssClasses.lblShowPossibleCombinations}
              onClick={() => this.btnShowPossibleCombinations_Click()}
            >
              Prikaži moguće kombinacije
            </span>
          </div>
        ) : null} */}

        {this.props.currentTicketTypeID === TICKET_TYPE_COMBO ? (
          <div className={CssClasses.infoGroup}>
            <span className={CssClasses.lblNumberOfBets}>
              Ukupni koeficijent:
            </span>
            <span className={CssClasses.lblSummary}>
              {GetConvertedOdds(
                this.props.currentOddFormat,
                this.props.totalOdds
              )}
            </span>
          </div>
        ) : null}

        <div
          className={[CssClasses.infoGroup, CssClasses.alternateRow].join(" ")}
        >
          <span className={CssClasses.lblNumberOfBets}>Mogući dobitak:</span>
          <span className={CssClasses.lblSummary}>
            {(this.getPossibleWin() * 0.01).toFixed(2)}
          </span>
        </div>
        {/* <div className={CssClasses.infoGroup}>
          <span className={CssClasses.lblNumberOfBets}>Tax:</span>
          <span className={CssClasses.lblSummary}>
            {" "}
            {(this.props.betAmount * this.props.totalOdds * 0.1).toFixed(2)}
          </span>
        </div> */}

        {this.props.currentTicketTypeID === TICKET_TYPE_COMBO ? (
          <div
            className={[
              CssClasses.infoGroup,
              CssClasses.alternateRow,
              CssClasses.amountRow
            ].join(" ")}
          >
            <span className={CssClasses.lblNumberOfBets}>Iznos:</span>
            <input
              type="text"
              className={[
                CssClasses.txtBetAmount,
                this.props.isShowingNumericKeyboard
                  ? CssClasses.txtBetAmountActive
                  : ""
              ].join(" ")}
              value={(this.props.betAmount * 0.01).toFixed(2)}
              // onChange={this.txtAmount_Change}
              onClick={this.txtAmount_Enter}
              onSelect={ev => {
                ev.target.selectionStart = ev.target.selectionEnd;
              }}
              readOnly
            />
          </div>
        ) : null}

        <div className={[CssClasses.infoGroup, CssClasses.buttonRow].join(" ")}>
          <button
            className={CssClasses.btnCancel}
            onClick={this.btnCancel_Click}
          >
            {this.state.isConfirmingBet ? "Odustani" : "Obriši"}
          </button>
          <button
            className={[
              CssClasses.btnPlaceBet,
              this.state.isConfirmingBet ? CssClasses.confirmBet : null
            ].join(" ")}
            onClick={this.btnPlaceBet_Click}
          >
            {this.state.isConfirmingBet ? "Potvrdi" : "Uplati listić"}
          </button>
        </div>

        {/* tost */}
        <div
          className={[
            CssClasses.snackbar,
            this.state.toastWarningMessage !== "" ? CssClasses.snackbarShow : ""
          ].join(" ")}
        >
          {this.state.toastWarningMessage}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isAppLoading: state.rrAppState.isLoading,
    ticketPairInfo: state.rrTicket.ticketPairInfo,
    betAmount: state.rrTicket.betAmount,
    totalOdds: state.rrTicket.totalOdds,
    numberOfBets: state.rrTicket.numberOfBets,
    numberOfBetsFormatted: state.rrTicket.numberOfBetsFormatted,
    isShowingNumericKeyboard: state.rrAppState.isShowingNumericKeyboard,
    currentOddFormat: state.rrAppState.oddFormatID,
    currentTicketTypeID: state.rrTicket.ticketTypeID,
    systemCombinations: state.rrTicket.systemCombinations,
    machineInfo: state.rrAppState.machineInfo,
    currentBalance: state.rrBalance.currentBalance,
    comboBetAmount: state.rrTicket.betAmount,
    currentComboTextboxID: state.rrTicket.currentlyEditedCombinationID
  };
};

const mapDispatchToProps = dispatch => {
  return {
    startLoading: (isTransparent, updateLocalStorage) =>
      dispatch(StoreActions.StartLoading(isTransparent, updateLocalStorage)),
    stopLoading: updateLocalStorage =>
      dispatch(StoreActions.StopLoading(updateLocalStorage)),
    onRemovePair: matchID => dispatch(StoreActions.RemovePair(matchID)),
    onSelectAllPairs: () => dispatch(StoreActions.SelectAllPairs()),
    onDeselectAllPairs: () => dispatch(StoreActions.DeselectAllPairs()),
    onRemoveAllPairs: () => dispatch(StoreActions.RemoveAllPairs()),
    onChangePairCheckedState: (matchID, checked) =>
      dispatch(StoreActions.ChangePairCheckedState(matchID, checked)),
    onTogglePairFixState: matchID =>
      dispatch(StoreActions.TogglePairFixState(matchID)),
    onRestoreTicketStateFromLocalStorage: ticketState =>
      dispatch(StoreActions.RestoreTicketStateFromLocalStorage(ticketState)),
    changeNumericKeyboardVisibility: isShown =>
      dispatch(StoreActions.SetNumericKeyboardVisibility(isShown)),
    setTicketNumberForDetails: ticketNumber =>
      dispatch(StoreActions.SetTicketNumberForDetails(ticketNumber)),
    updateBetAmount: newAmount =>
      dispatch(StoreActions.SetBetAmount(newAmount)),
    setTicketType: ticketType =>
      dispatch(StoreActions.SetTicketType(ticketType)),
    toggleSystemActiveState: systemID =>
      dispatch(StoreActions.ToggleSystemActiveState(systemID)),
    setIsShowingSystemCombinationsPopup: isShowing =>
      dispatch(StoreActions.SetIsShowingSystemCombinationsPopup(isShowing)),
    setCurrentlyEditedCombinationID: combID =>
      dispatch(StoreActions.SetCurrentlyEditedCombinationID(combID)),
    updateCombinationBetAmount: (combinationID, newAmount) =>
      dispatch(StoreActions.SetCombinationBetAmount(combinationID, newAmount))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Ticket);



// WEBPACK FOOTER //
// ./src/Components/Ticket/Ticket.js